import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { Card, CardContent, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { LeadTimeRecord } from '@src/types/leadtime'

interface LeadTimeDataTableProps {
  records: LeadTimeRecord[]
}

const LeadTimeDataTable = ({ records }: LeadTimeDataTableProps) => {
  const { t } = useTranslation()

  const formatDate = (dateString: string) => {
    return new Date(dateString).toISOString().split('T')[0]
  }

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: t('leadTime.table.itemId'),
      width: 100,
    },
    {
      field: 'workItemName',
      headerName: t('leadTime.table.itemName'),
      width: 300,
      flex: 1,
    },
    {
      field: 'parentName',
      headerName: t('leadTime.table.parentName'),
      width: 250,
    },
    {
      field: 'closedDate',
      headerName: t('leadTime.table.closedDate'),
      width: 150,
      valueFormatter: (value) => formatDate(value),
    },
    {
      field: 'mergedToMasterDate',
      headerName: t('leadTime.table.mergedDate'),
      width: 150,
      valueFormatter: (value) => formatDate(value),
    },
    {
      field: 'leadTimeDays',
      headerName: t('leadTime.table.leadTimeDays'),
      width: 120,
      type: 'number',
    },
  ]

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t('leadTime.table.title')}
        </Typography>
        <DataGrid
          rows={records}
          columns={columns}
          pageSizeOptions={[10, 25, 50, 100]}
          initialState={{
            pagination: { paginationModel: { pageSize: 25 } },
          }}
          disableRowSelectionOnClick
        />
      </CardContent>
    </Card>
  )
}

export default LeadTimeDataTable
